import React from 'react'
import PropTypes from 'prop-types'
import some from 'lodash/some'
import cx from 'classnames'
import find from 'lodash/find'
import SwatchColor from './SwatchColor'
import Text from 'cms/CmsText'
import styled from 'styled-components'
import { createDynamicStyle } from 'cms/helpers/styledComponents'

const isSomeValidAttributes = (attributeData, attributes) => {
  return some(attributes, ({ code: mapCode }) => {
    // some attribute match
    return !!find(attributeData, ({ code }) => code === mapCode)
  })
}

const Attributes = ({
  attributeRule,
  attributeData,
  className,
}) => {
  const filteredAttributes = attributeRule.filter(({ active }) => active)
  const renderByType = (key, type, options, attribute) => {
    switch (type) {
      case 'swatch_color':
        return (
          <SwatchColor.Group
            key={key}
            colors={options.map(({ value }) => value)}
          />
        )
      case 'swatch_text':
        return (
          <div key={key}>
            <Text className="attribute-title" size="small" bold>
              AVAILABLE {attribute.label}
            </Text>
            <div className="attribute-detail">
              {renderAttributeOption(options)}
            </div>
          </div>
        )
      case 'select':
        return (
          <div key={key}>
            <Text className="attribute-title" size="small" bold>
              AVAILABLE {attribute.label}
            </Text>
            <div className="attribute-detail">
              {renderAttributeOption(options)}
            </div>
          </div>
        )
      default:
        return null
    }
  }
  const renderAttributeOption = (options) => {
    if (options.length > 5) {
      return <Text size="tiny">see more</Text>
    }

    return options.map(({ label }, i) => (
      <Text key={i} size="tiny">{label}</Text>
    ))
  }
  return (
    filteredAttributes.length &&
    isSomeValidAttributes(attributeData, filteredAttributes)
  ) ? (
    <div className={cx(className, 'product-attributes')}>
      {filteredAttributes.map(({ code: mapCode }) => {
        const attribute = find(attributeData, ({ code }) => code === mapCode)
        if (!attribute) {
          return null
        }
        const type = attribute.options.length ? attribute.options[0].type : ''
        return renderByType(mapCode, type, attribute.options, attribute)
      })}
    </div>
  ) : null
}

Attributes.propTypes = {
  className: PropTypes.string,
  attributeData: PropTypes.array,
  attributeRule: PropTypes.array,
}
Attributes.defaultProps = {
  className: undefined,
  attributeData: [],
  attributeRule: [],
}
Attributes.Overlay = styled(Attributes)`
  ${({ theme, show }) => ({
    ...createDynamicStyle(theme, 'cms', 'productCard', 'attributeOverlay')({
      opacity: show ? 1 : 0,
    })
  })}
`


export default Attributes



// WEBPACK FOOTER //
// ./src/cms/components/productCard/Attributes.js